import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGh = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-gh"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#006b3f" d="M0 0h640v480H0z" />
    <path fill="#fcd116" d="M0 0h640v320H0z" />
    <path fill="#ce1126" d="M0 0h640v160H0z" />
    <path fill="#000001" d="m320 160 52 160-136.1-98.9H404L268 320z" />
  </svg>
);
export default SvgGh;
